/**
 * A global namespace for `touchcancel` event.
 */
const tabindex = 'tabindex';
export default tabindex;
